// -------------------------------------------------------------------------------
// Library
// -------------------------------------------------------------------------------
import React from "react";
import { Divider, Form, Input, Button as IconButton, Typography, Flex } from "antd";

// -------------------------------------------------------------------------------
// Store
// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------
import { Button } from "components/Common/Button";
import { GeneralInformationCard } from "components/Common/Cards/InformationCard";

// -------------------------------------------------------------------------------
// Utils, Styles and Assets
// -------------------------------------------------------------------------------
import StyledGymSearch from "./styles";
import { useLazySearchGymsQuery } from "store/api/api";
import { FullLogoIcon } from "components/Icons";
import getStartedHero from "../../images/sweatbase-header.jpg";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const REQUEST_DEMO_LABEL = "Request a Demo";

function useNavigateToAnchor() {
	const navigate = useNavigate();

	return (path, anchor) => {
		navigate(path, {
			replace: false,
		});

		setTimeout(() => {
			const el = document.getElementById(anchor);
			if (el) {
				el.scrollIntoView({ behavior: "smooth" });
			}
		}, 50);
	};
}

const Header = () => {
	const navigateToAnchor = useNavigateToAnchor();
	return (
		<div className="sb-gym-search__main-section__header">
			<div style={{ zIndex: 3 }}>
				<Link to="/">
					<FullLogoIcon />
				</Link>
			</div>
			<div className="actions">
				<Button onClick={() => navigateToAnchor("/", "request-demo")} className="orange-btn">
					{REQUEST_DEMO_LABEL}
				</Button>
			</div>
		</div>
	);
};

const Footer = () => {
	return (
		<div className="sb-gym-search__main-section__footer">
			<div className="">
				<FullLogoIcon />
			</div>
			<Divider className="divider" size="small" />
			<div className="copyright">© Copyright 2012 - {new Date().getFullYear()}. All Rights Reserved.</div>
		</div>
	);
};

const GymSearch = () => {
	const [trigger] = useLazySearchGymsQuery({});
	const [result, setResult] = React.useState([]);
	const load = async (term) => {
		const zipData = {
			zip: term ?? "",
			term: "",
		};

		const termData = {
			zip: "",
			term: term ?? "",
		};

		const [{ data: data1 }, { data: data2 }] = await Promise.all([trigger(zipData), trigger(termData)]);
		const combinedResults = [...(data1?.gyms || []), ...(data2?.gyms || [])];
		setResult(combinedResults);
	};

	const onFinishForm = ({ mainSearch }) => {
		load(mainSearch);
	};

	return (
		<StyledGymSearch>
			<div
				className="sb-gym-search__main-section"
				style={{
					backgroundImage: `url(${getStartedHero})`,
				}}
			>
				<Header />
				<div className="sb-gym-search__search">
					<div className="sb-gym-search__search__inner">
						<div className="sb-gym-search__search__inner__header">
							<p className="clash-display title">Find My Gym</p>
							<p className="subtitle">Enter city or zip code to find nearby gyms</p>
							<div className="sb-gym-search__search__inner__header">
								<Form onFinish={onFinishForm} layout="inline">
									<Form.Item name="mainSearch" style={{ margin: "0px", padding: "0px", flex: 1, height: 48 }}>
										<Input
											addonAfter={
												<IconButton
													className="orange-btn"
													htmlType="submit"
													data-id="btnSearch"
													icon={<SearchOutlined />}
													style={{ width: 40 }}
												/>
											}
											placeholder="Search by City or Zip Code"
											autoComplete={"off"}
											data-id="txtInputSearch"
											style={{ border: "none", borderColor: "#fff", height: 48, flex: 1, width: "100%" }}
										/>
									</Form.Item>
								</Form>
							</div>
						</div>
						<Flex vertical justify="center" style={{ width: "100%" }} align="center">
							{result && (
								<Typography.Text style={{ color: "#fff", fontSize: "16px" }} color="secondary">
									{result?.length} result{result?.length > 1 ? "s" : ""} found
								</Typography.Text>
							)}
							<div className="sb-gym-search__search__inner__result" data-id="sectionSearchResult">
								{result &&
									result.map(({ id, light_logo, address1, name, zipcode, city, state, subdomain }) => {
										const addressParts = [address1, city, state, zipcode].filter(Boolean);
										const addressText = addressParts.join(", ");

										return (
											<GeneralInformationCard
												key={id}
												url={`/login/${subdomain}`}
												icon={
													<img style={{ borderRadius: "50%" }} src={light_logo} height={32} width={32} alt="gym-logo" />
												}
												header={name}
												text={addressText}
												transparent
											/>
										);
									})}
							</div>
						</Flex>
					</div>
				</div>
				<Footer />
			</div>
		</StyledGymSearch>
	);
};

export default GymSearch;

